/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowActivity200ResponseDataUser } from './ShowActivity200ResponseDataUser';
import {
    ShowActivity200ResponseDataUserFromJSON,
    ShowActivity200ResponseDataUserFromJSONTyped,
    ShowActivity200ResponseDataUserToJSON,
    ShowActivity200ResponseDataUserToJSONTyped,
} from './ShowActivity200ResponseDataUser';
import type { ShowCar200ResponseDataVideosInner } from './ShowCar200ResponseDataVideosInner';
import {
    ShowCar200ResponseDataVideosInnerFromJSON,
    ShowCar200ResponseDataVideosInnerFromJSONTyped,
    ShowCar200ResponseDataVideosInnerToJSON,
    ShowCar200ResponseDataVideosInnerToJSONTyped,
} from './ShowCar200ResponseDataVideosInner';
import type { ListActivities200ResponseDataInner } from './ListActivities200ResponseDataInner';
import {
    ListActivities200ResponseDataInnerFromJSON,
    ListActivities200ResponseDataInnerFromJSONTyped,
    ListActivities200ResponseDataInnerToJSON,
    ListActivities200ResponseDataInnerToJSONTyped,
} from './ListActivities200ResponseDataInner';

/**
 * 
 * @export
 * @interface ShowCar200ResponseData
 */
export interface ShowCar200ResponseData {
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseData
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseData
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseData
     */
    garageId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    intro?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    make?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    model?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseData
     */
    year?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowCar200ResponseData
     */
    photoUrls?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ShowCar200ResponseData
     */
    isPublic?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseData
     */
    ratingAverage?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseData
     */
    ratingCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    myRating?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    myContributionStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShowCar200ResponseData
     */
    canContribute?: boolean;
    /**
     * 
     * @type {ShowActivity200ResponseDataUser}
     * @memberof ShowCar200ResponseData
     */
    user?: ShowActivity200ResponseDataUser;
    /**
     * 
     * @type {Array<ShowCar200ResponseDataVideosInner>}
     * @memberof ShowCar200ResponseData
     */
    videos?: Array<ShowCar200ResponseDataVideosInner>;
    /**
     * 
     * @type {Array<ListActivities200ResponseDataInner>}
     * @memberof ShowCar200ResponseData
     */
    activities?: Array<ListActivities200ResponseDataInner>;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseData
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowCar200ResponseData interface.
 */
export function instanceOfShowCar200ResponseData(value: object): value is ShowCar200ResponseData {
    return true;
}

export function ShowCar200ResponseDataFromJSON(json: any): ShowCar200ResponseData {
    return ShowCar200ResponseDataFromJSONTyped(json, false);
}

export function ShowCar200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowCar200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'garageId': json['garage_id'] == null ? undefined : json['garage_id'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'intro': json['intro'] == null ? undefined : json['intro'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'make': json['make'] == null ? undefined : json['make'],
        'model': json['model'] == null ? undefined : json['model'],
        'year': json['year'] == null ? undefined : json['year'],
        'photoUrls': json['photo_urls'] == null ? undefined : json['photo_urls'],
        'isPublic': json['is_public'] == null ? undefined : json['is_public'],
        'ratingAverage': json['rating_average'] == null ? undefined : json['rating_average'],
        'ratingCount': json['rating_count'] == null ? undefined : json['rating_count'],
        'myRating': json['my_rating'] == null ? undefined : json['my_rating'],
        'myContributionStatus': json['my_contribution_status'] == null ? undefined : json['my_contribution_status'],
        'canContribute': json['can_contribute'] == null ? undefined : json['can_contribute'],
        'user': json['user'] == null ? undefined : ShowActivity200ResponseDataUserFromJSON(json['user']),
        'videos': json['videos'] == null ? undefined : ((json['videos'] as Array<any>).map(ShowCar200ResponseDataVideosInnerFromJSON)),
        'activities': json['activities'] == null ? undefined : ((json['activities'] as Array<any>).map(ListActivities200ResponseDataInnerFromJSON)),
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowCar200ResponseDataToJSON(json: any): ShowCar200ResponseData {
    return ShowCar200ResponseDataToJSONTyped(json, false);
}

export function ShowCar200ResponseDataToJSONTyped(value?: ShowCar200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'garage_id': value['garageId'],
        'nickname': value['nickname'],
        'display_name': value['displayName'],
        'slug': value['slug'],
        'intro': value['intro'],
        'summary': value['summary'],
        'make': value['make'],
        'model': value['model'],
        'year': value['year'],
        'photo_urls': value['photoUrls'],
        'is_public': value['isPublic'],
        'rating_average': value['ratingAverage'],
        'rating_count': value['ratingCount'],
        'my_rating': value['myRating'],
        'my_contribution_status': value['myContributionStatus'],
        'can_contribute': value['canContribute'],
        'user': ShowActivity200ResponseDataUserToJSON(value['user']),
        'videos': value['videos'] == null ? undefined : ((value['videos'] as Array<any>).map(ShowCar200ResponseDataVideosInnerToJSON)),
        'activities': value['activities'] == null ? undefined : ((value['activities'] as Array<any>).map(ListActivities200ResponseDataInnerToJSON)),
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

